import { InfoField } from '@occc/ui-design-system';
import { ConstraintFragment } from '@occc/graphql';
import { Fragment } from 'react';
import { hasConfiguredRequiresActivationConstraint } from '@occc/feat-constraints';
import { formatValues, formatYesNoValues } from '../../formatters';
import { InfoFieldRow } from '../../../components';
import { getConstraintsByType } from '../constraints-section.utils';

export const getActivationRequiredConstraintBlocks = (constraints: ConstraintFragment[]) => {
  const cst = getConstraintsByType('ConstraintRequiresActivation', constraints);
  const configuredConstraints = cst.filter(hasConfiguredRequiresActivationConstraint);

  const requiresActivationValue = formatYesNoValues([cst.length > 0]);
  const mustFulfillValue = formatValues(configuredConstraints.map((c) => c.mustFulfillWithinDays));
  const allowMultipleValue = formatYesNoValues(
    configuredConstraints.map((c) => c.allowMultipleFulfillmentsOnActivation),
  );

  return [
    <InfoField label='Requires Activation' value={requiresActivationValue} />,
    <InfoField label='Must Fulfill Within (Days)' value={mustFulfillValue} />,
    <InfoField label='Multiple Fulfillments On Activation' value={allowMultipleValue} />,
  ];
};

export const ActivationRequiredConstraint = ({
  constraints,
}: {
  constraints: ConstraintFragment[];
}) => {
  const blocks = getActivationRequiredConstraintBlocks(constraints);

  return (
    <InfoFieldRow cols={3}>
      {blocks.map((block, index) => (
        <Fragment key={index}>{block}</Fragment>
      ))}
    </InfoFieldRow>
  );
};
